import { Link } from "react-router-dom";
import { NotFoundContainer } from "./NotFoundPage.style";

/**
 * 어떤 라우트에도 매칭되지 않은 경로.
 *
 * react-router v6 는 매칭이 없으면 아무것도 렌더하지 않아 그냥 백지가 된다.
 * 사용자가 오타를 쳤는지 서비스가 죽었는지 구별할 수 없으므로 catch-all 로 받는다.
 */
function NotFoundPage({ message }: { message?: string }) {
  return (
    <NotFoundContainer>
      <span className="code">404</span>
      <span className="message">{message ?? "페이지를 찾을 수 없습니다."}</span>
      <span className="hint">주소가 바뀌었거나 삭제된 것 같습니다.</span>
      <Link to="/">전체 게시글로 가기</Link>
    </NotFoundContainer>
  );
}

export default NotFoundPage;
